import React from 'react';
import wageLogo from '../../wagelogo.png';
import './Footer.css';

const Footer = ({ onFeedbackClick }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* <div className="footer-content">
        <div className="footer-section">
          <div className="footer-branding">
            <h3 className="footer-title">Lotus STEMM × Campfire Kinship</h3>
            <p className="footer-description">
              Empowering South Asian women through education, mentorship, and community support.
            </p>
          </div>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <h4 className="footer-heading">Platform</h4>
            <ul className="footer-list">
              <li><a href="#modules">Modules</a></li>
              <li><a href="#resources">Resources</a></li>
              <li><a href="#forum">Discussion Forum</a></li>
              <li><a href="#certificates">Certificates</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-list">
              <li><a href="#help">Help Center</a></li>
              <li><a href="#faq">FAQs</a></li>
              <li><a href="#contact">Contact Us</a></li>
              <li><a href="#feedback">Feedback</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">About</h4>
            <ul className="footer-list">
              <li><a href="#lotus">Lotus STEMM</a></li>
              <li><a href="#campfire">Campfire Kinship</a></li>
              <li><a href="#partnership">Our Partnership</a></li>
              <li><a href="#funders">Funders</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Legal</h4>
            <ul className="footer-list">
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><a href="#terms">Terms of Service</a></li>
              <li><a href="#accessibility">Accessibility</a></li>
            </ul>
          </div>
        </div>
      </div> */}

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="footer-top-row">
            <div className="footer-left-block">
              <div className="footer-wage-block">
                <a
                  href="https://www.canada.ca/en/women-gender-equality.html"
                  className="footer-wage-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={wageLogo}
                    alt="Women and Gender Equality Canada"
                    className="footer-wage-logo"
                    decoding="async"
                  />
                </a>
              </div>
            </div>
            <div className="footer-center-block">
              <p className="footer-funder-note">
                This work is funded by WAGE systemic change project 2024-2027.
              </p>
              <p className="copyright">
                © {currentYear} Lotus STEMM & Campfire Kinship. All rights reserved.
              </p>
            </div>
            <div className="footer-right-actions" id="footer-fab-anchor">
              <div className="footer-social-wrap">
                <div className="social-links">
                  <a
                    href="https://www.linkedin.com/company/lotusstemm"
                    className="social-link"
                    aria-label="LinkedIn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                    </svg>
                  </a>
                  <a
                    href="https://twitter.com/Lotus_STEMM"
                    className="social-link"
                    aria-label="Twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                    </svg>
                  </a>
                  <a
                    href="https://www.instagram.com/lotusstemm/"
                    className="social-link"
                    aria-label="Instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                      <circle cx="12" cy="12" r="4"/>
                      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
                    </svg>
                  </a>
                  <a
                    href="https://www.facebook.com/Lotus-STEMM-516616715543533/"
                    className="social-link"
                    aria-label="Facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                    </svg>
                  </a>
                </div>
              </div>
              {typeof onFeedbackClick === 'function' && (
                <button
                  type="button"
                  className="footer-feedback-btn"
                  onClick={onFeedbackClick}
                  aria-label="Send feedback"
                  title="Send feedback"
                >
                  <span className="footer-feedback-btn-icon" aria-hidden="true">💬</span>
                  <span className="footer-feedback-btn-label">Feedback</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

